import { render, staticRenderFns } from "./regressionRowOld.vue?vue&type=template&id=80bafa56&scoped=true"
import script from "./regressionRowOld.vue?vue&type=script&lang=js"
export * from "./regressionRowOld.vue?vue&type=script&lang=js"
import style0 from "./regressionRowOld.vue?vue&type=style&index=0&id=80bafa56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bafa56",
  null
  
)

export default component.exports